import { GlobalStyles } from "@mui/system";

export const MaterialGlobalStyles = () => {
  return (
    <GlobalStyles
      styles={{
        ".MuiPopper-root": {
          zIndex: 1,
        },
      }}
    />
  );
};
